import React, { createContext, useEffect, useReducer } from 'react'
import jwtDecode from 'jwt-decode'
import axios from 'axios.js'
import { MatxLoading } from 'app/components'

// import AjexPortalService from "app/services/api"
import { UserService } from 'app/services/UserService'
import { InsertInvitation } from '@mui/icons-material'
import useIdleLogout from 'app/hooks/useIdleLogout'
const loginURL = process.env.REACT_APP_API_AUTHENTICATION_URL;

const WMSInbondURL = process.env.REACT_APP_API_WMSINBOUND_URL;
const baseUrl = `${WMSInbondURL}user`;

const initialState = {
    isAuthenticated: false,
    isInitialised: false,
    user: {
        id: 1,
        role: 'SA',
        firstName: 'Mateen Mohammed Taher',
        lastName: 'Mateen Mohammed Taher',
        username: '123',
        email: 'mateen.deshmukh@aj-ex.com',
        avatar: '/assets/images/face-6.jpg',
        age: 25
    },
}

const isValidToken = (accessToken) => {
    if (!accessToken) {
        return false
    }

    const decodedToken = jwtDecode(accessToken)
    const currentTime = Date.now() / 1000
    return decodedToken.exp > currentTime
}

const setSession = (accessToken) => {
    if (accessToken) {

        localStorage.setItem('accessToken', accessToken)
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    } else {
        localStorage.removeItem('accessToken')
        delete axios.defaults.headers.common.Authorization
    }
}
const setUserSession = (username) => {
    if (username) {
        ;
        localStorage.setItem('username', username)

    } else {
        localStorage.removeItem('username')

    }
}
const setUserObjectSession = (user) => {
    if (user) {
        ;
        localStorage.setItem('userobject', JSON.stringify(user))

    } else {
        localStorage.removeItem('userobject')

    }
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'INIT': {
            const { isAuthenticated, user } = action.payload

            return {
                ...state,
                isAuthenticated,
                isInitialised: true,
                user,
            }
        }
        case 'LOGIN': {
            const { user } = action.payload

            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        case 'LOGOUT': {
            return {
                ...state,
                isAuthenticated: false,
                user: null,
            }
        }
        case 'REGISTER': {
            const { user } = action.payload

            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        default: {
            return { ...state }
        }
    }
}

const AuthContext = createContext({
    ...initialState,
    method: 'JWT',
    login: () => Promise.resolve(),
    logout: () => { },
    register: () => Promise.resolve(),
})

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const login = async (formData) => {


        localStorage.removeItem('accessToken')
        delete axios.defaults.headers.common.Authorization
        const response = await axios.post(loginURL + 'login', formData);
        const { accessToken } = response.data


        setSession(accessToken)

        // const res = await axios.get(`${baseUrl}/user-name?userName=${formData.username}`);
        const res = await axios.get(`${baseUrl}/get-user-data`);

        if (res == undefined) {

            logout();
            return;
        }
        else {
            if (res.data.data.userTypeId === 1) {
                //AlertService.info("User Type is not Operation")
                alert("User does not have authorized to access portal");
                logout();
                return;

            }
            initialState.user = res.data.data;
            const { username } = res.data.data;

            setUserObjectSession(res.data.data);
            setUserSession(username);
        }


        dispatch({
            type: 'LOGIN',
            payload: {
                user: initialState.user,
            },
        })
    }

    const register = async (formData) => {
        // const response = await axios.post('/api/auth/register', {
        //     email,
        //     username,
        //     password,
        // })

        const response = await axios.post(loginURL + 'register', formData)

        const { accessToken, user } = response.data
        if (response.status == 200) {

        }
        //setSession(accessToken)

        dispatch({
            type: 'REGISTER',
            payload: {
                user,
            },
        })
    }

    const logout = () => {
        setSession(null)
        dispatch({ type: 'LOGOUT' })
    }

    useEffect(() => {
        ; (async () => {
            try {
                ;
                const accessToken = window.localStorage.getItem('accessToken')
                const username = window.localStorage.getItem('username')
                //const userobj = JSON.parse(window.localStorage.getItem('userobject'));

                if (accessToken && isValidToken(accessToken)) {
                    setSession(accessToken)
                    //const response = await axios.get('/api/auth/profile')
                    //const res = await axios.get(`${baseUrl}/user-name?userName=${username}`);
                    const userobj = JSON.parse(window.localStorage.getItem('userobject'));
                    if (userobj == undefined) {

                        logout();
                        return;
                    }
                    else {
                        ;
                        //initialState.user = res.data.data;
                        //const { username } = res.data.data;
                        initialState.user = userobj;
                        setUserSession(userobj.username);
                    }


                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: true,
                            user: initialState.user,
                        },
                    })
                } else {

                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: false,
                            user: null,
                        },
                    })
                }
            } catch (err) {
                console.error(err)
                dispatch({
                    type: 'INIT',
                    payload: {
                        isAuthenticated: false,
                        user: null,
                    },
                })
            }
        })()
    }, [])

    useIdleLogout(logout);

    if (!state.isInitialised) {
        return <MatxLoading />
    }

    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: 'JWT',
                login,
                logout,
                register,
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext
